import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public usuariosesion;
  public clientesesion;
  public chatgpt_asistente;
  public lista_asistentes = [];
  //PRUEBAS

  // public url_ws = 'http://192.168.1.244/intelliassist/ws/ws_intelliassist/public/api/';
  //public url_ws_imagenes = 'http://192.168.1.244/intelliassist/ws/ws_intelliassist/storage/app/imagenes/';
  //REAL
  public url_ws = 'https://www.intelliassist.es/ws/ws_intelliassist/public/api/';
  public url_ws_imagenes = 'https://www.intelliassist.es/ws/ws_intelliassist/storage/app/imagenes/';
  constructor() { }

  logout() {
    localStorage.removeItem('usuario');
    this.usuariosesion = null;
   
  }

  recuperaUsuario() {
    this.usuariosesion = JSON.parse(localStorage.getItem('usuario'));
    this.clientesesion = JSON.parse(localStorage.getItem('cliente'));
  }

  
}
